import { render, staticRenderFns } from "./OasisPark.vue?vue&type=template&id=f7a6216a&scoped=true&"
import script from "./OasisPark.vue?vue&type=script&lang=js&"
export * from "./OasisPark.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/static-pages/oasis-park.scss?vue&type=style&index=0&id=f7a6216a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a6216a",
  null
  
)

export default component.exports